import type { FeatureKey } from '../types/content';

export const siteConfig = {
  name: 'Qorvessa Executive Partners',
  /**
   * Feature switches. Set `consultants` to true once approved team information,
   * biographies, portraits, and contact details are ready, then register the
   * consultants pages in App.tsx. While false, legacy consultant URLs redirect
   * to the Contact page and no consultant links render anywhere.
   */
  features: {
    consultants: false,
  } as Record<FeatureKey, boolean>,
  /**
   * Endpoint that receives inquiry form submissions as a JSON POST and returns
   * a 2xx status on success (e.g. a Formspree/Basin form URL or your own API).
   * Leave empty until a submission service is connected.
   */
  inquiryEndpoint: '',
};
